// Constants the financial domain depends on, true for every installation
// regardless of which extensions are loaded.
//
// No institution name belongs here, and none may be added: which institutions
// exist is a fact about the extensions installed, never about the application.

import { SYSTEM_KEYS } from "@/finance/model/vocabulary.js";

/** The reporting currency every balance, position and statement row is stated in. */
export const BASE_CURRENCY = "CHF";

/** A brokerage's balance the application keeps from what it holds, in the
 *  reporting currency. */
export const INVESTED_BALANCE = "Invested";

/** The institution that speaks for the person: physical cash, and anything
 *  nobody else holds on their behalf. One per installation, guaranteed by the
 *  seed, and where every record naming no institution lands — the type is
 *  what identifies it, so the name is the person's to change. */
export const SELF_INSTITUTION_TYPE = "self";

/** What the application calls a brokerage it has to create itself: a figure
 *  arrives for a broker and there is nowhere at that institution to put it.
 *  An account is named by what it is, never by where it is, so this is the
 *  neutral word for the account a broker holds. */
export const BROKERAGE_ACCOUNT_NAME = "Portfolio";
export const SELF_INSTITUTION_NAME = "Self";

/**
 * The categories the application itself routes on, named by what they do
 * rather than by what they are called.
 *
 * A key lives in `transaction_categories.system_key`, so renaming a category
 * cannot silently change the cash-flow statement. `pillar_2` and `pillar_3a`
 * sit on secondary categories rather than primary ones.
 */
export { SYSTEM_KEYS };

export type SystemKey = (typeof SYSTEM_KEYS)[number];

/** The source the market's open and close are sent as. */
export const MARKET_NOTIFICATIONS = "market";
